import React, { useState } from 'react';
import {
  Table, Card, Button, Space, Typography, Form, Input, Select,
  Tag, DatePicker, Tabs, Statistic, Row, Col, Tooltip, Drawer, Descriptions
} from 'antd';
import { SearchOutlined, ReloadOutlined, FileTextOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

// ══════════════════════════════════════════════
//  Mock 数据 — 规则总览（多级，含国家）
// ══════════════════════════════════════════════
const MOCK_RULES = [
  { key: 'r1', level: 'top', fromEntName: '捷顺科技股份有限公司', fromEntId: 'test-source-001', toEntName: '杭州智联科技有限公司', toEntId: 'test-ent-001', appName: '智能家居控制-iOS-海外', appId: 'test-app-001', mode: 'manual', baseRatio: 80, customRatios: [{ country: '美国', ratio: 90 }], status: 'active', updateTime: '2026-07-28 14:30:00' },
  { key: 'r2', level: 'top', fromEntName: '捷顺科技股份有限公司', fromEntId: 'test-source-001', toEntName: '成都云视科技有限公司', toEntId: 'test-ent-002', appName: '智能家居控制-Android-国内', appId: 'test-app-001', mode: 'manual', baseRatio: 60, customRatios: [], status: 'active', updateTime: '2026-07-27 10:15:00' },
  { key: 'r3', level: 'top', fromEntName: '东莞康林物联网有限公司', fromEntId: 'test-source-002', toEntName: '广州云联物联网有限公司', toEntId: 'test-ent-003', appName: '云视监控-Android-海外', appId: 'test-app-002', mode: 'auto', baseRatio: 50, customRatios: [], status: 'stopped', updateTime: '2026-07-25 09:00:00' },
  { key: 'r4', level: 'top', fromEntName: '捷顺科技股份有限公司', fromEntId: 'test-source-001', toEntName: '杭州智联科技有限公司', toEntId: 'test-ent-001', appName: '云视监控-iOS-海外', appId: 'test-app-002', mode: 'manual', baseRatio: 100, customRatios: [], status: 'active', updateTime: '2026-07-30 16:45:00' },
  { key: 'r5', level: 'sub', fromEntName: '杭州智联科技有限公司', fromEntId: 'test-ent-001', toEntName: '智联华东分销', toEntId: 'test-sub-001', appName: '—', appId: '—', mode: 'manual', baseRatio: 50, customRatios: [{ country: '美国', ratio: 40 }], status: 'active', updateTime: '2026-07-28 15:00:00' },
  { key: 'r6', level: 'sub', fromEntName: '杭州智联科技有限公司', fromEntId: 'test-ent-001', toEntName: '智联华南分销', toEntId: 'test-sub-002', appName: '—', appId: '—', mode: 'manual', baseRatio: 30, customRatios: [], status: 'active', updateTime: '2026-07-27 11:30:00' },
];

// ══════════════════════════════════════════════
//  Mock 数据 — 账单总览（多级合并，含国家明细）
// ══════════════════════════════════════════════
const MOCK_BILLS = [
  { key: 'b1', billDate: '2026-08-01', fromEntName: '捷顺科技股份有限公司', fromEntId: 'test-source-001', toEntName: '杭州智联科技有限公司', toEntId: 'test-ent-001', appName: '智能家居控制-iOS-海外', appId: 'test-app-001', totalRevenue: '¥32,000.00', activeNum: 320, activeDenom: 1024, ratio: 80, customCountryCount: 2, currency: 'CNY', amount: 8000.00, billType: 'system', remark: '',
    countries: [{ country: '美国', activeNum: 120, activeDenom: 400, ratio: 90, amount: 1200.00, currency: 'CNY' }, { country: '日本', activeNum: 80, activeDenom: 300, ratio: 80, amount: 640.00, currency: 'CNY' }, { country: '韩国', activeNum: 120, activeDenom: 324, ratio: 80, amount: 640.00, currency: 'CNY' }] },
  { key: 'b2', billDate: '2026-08-01', fromEntName: '杭州智联科技有限公司', fromEntId: 'test-ent-001', toEntName: '智联华东分销', toEntId: 'test-sub-001', appName: '—', appId: '—', totalRevenue: '¥8,000.00', activeNum: 120, activeDenom: 320, ratio: 50, customCountryCount: 1, currency: 'CNY', amount: 1500.00, billType: 'system', remark: '',
    countries: [{ country: '中国', activeNum: 60, activeDenom: 180, ratio: 50, amount: 750.00, currency: 'CNY' }, { country: '美国', activeNum: 60, activeDenom: 140, ratio: 40, amount: 750.00, currency: 'CNY' }] },
  { key: 'b3', billDate: '2026-07-01', fromEntName: '东莞康林物联网有限公司', fromEntId: 'test-source-002', toEntName: '广州云联物联网有限公司', toEntId: 'test-ent-003', appName: '云视监控-iOS-海外', appId: 'test-app-002', totalRevenue: '$10,000.00', activeNum: 200, activeDenom: 800, ratio: 80, customCountryCount: 0, currency: 'USD', amount: 2000.00, billType: 'system', remark: '',
    countries: [{ country: '美国', activeNum: 200, activeDenom: 800, ratio: 80, amount: 2000.00, currency: 'USD' }] },
  { key: 'b4', billDate: '2026-08-03', fromEntName: '捷顺科技股份有限公司', fromEntId: 'test-source-001', toEntName: '杭州智联科技有限公司', toEntId: 'test-ent-001', appName: '智能家居控制-iOS-海外', appId: 'test-app-001', totalRevenue: '—', activeNum: 0, activeDenom: 0, ratio: null, customCountryCount: 0, currency: 'CNY', amount: -500.00, billType: 'adjust', remark: '7月账单多计，冲回差额',
    countries: [] },
];

const MODE_MAP = { manual: '手动配置', auto: '自动配置' };
const LEVEL_MAP = { top: 'App企业 → 设备企业', sub: '设备企业 → 下级分销' };
const BILL_TYPE_MAP = { system: '系统出账', adjust: '人工冲账' };

// 比例展示：统一比例 + 自定义国家 Tag
const renderRatio = (record) => (
  <Space size={4} wrap>
    <Text strong style={{ color: '#1677ff' }}>{record.baseRatio}%</Text>
    {record.customRatios && record.customRatios.length > 0 && (
      record.customRatios.length <= 2
        ? record.customRatios.map((c, i) => (
            <Tooltip key={i} title={`${c.country} 自定义比例`}>
              <Tag color="orange" style={{ border: 'none' }}>{c.country} {c.ratio}%</Tag>
            </Tooltip>
          ))
        : <Tooltip title={record.customRatios.map((c) => `${c.country} ${c.ratio}%`).join('；')}>
            <Tag color="orange" style={{ border: 'none' }}>自定义{record.customRatios.length}国</Tag>
          </Tooltip>
    )}
  </Space>
);

// ══════════════════════════════════════════════
//  子组件：规则总览 Tab
// ══════════════════════════════════════════════
const RulesTab = () => {
  const [filterFromEnt, setFilterFromEnt] = useState('');
  const [filterToEnt, setFilterToEnt] = useState('');
  const [filterLevel, setFilterLevel] = useState(undefined);
  const [filterStatus, setFilterStatus] = useState(undefined);

  const filtered = MOCK_RULES.filter((r) => {
    if (filterFromEnt && !(r.fromEntName + r.fromEntId).toLowerCase().includes(filterFromEnt.toLowerCase())) return false;
    if (filterToEnt && !(r.toEntName + r.toEntId).toLowerCase().includes(filterToEnt.toLowerCase())) return false;
    if (filterLevel && r.level !== filterLevel) return false;
    if (filterStatus && r.status !== filterStatus) return false;
    return true;
  });

  const columns = [
    { title: '分润企业', dataIndex: 'fromEntName', width: 150, render: (text, r) => <div><Text strong>{text}</Text><br /><Text type="secondary" style={{ fontSize: 12 }}>{r.fromEntId}</Text></div> },
    { title: '分润对象', dataIndex: 'toEntName', width: 150, render: (text, r) => <div><Text>{text}</Text><br /><Text type="secondary" style={{ fontSize: 12 }}>{r.toEntId}</Text></div> },
    { title: '分润 App', dataIndex: 'appName', width: 170, render: (text, r) => <div><Text>{text}</Text><br /><Text type="secondary" style={{ fontSize: 12 }}>{r.appId}</Text></div> },
    { title: '配置模式', dataIndex: 'mode', width: 90, render: (v) => <Tag color={v === 'manual' ? 'blue' : 'purple'} style={{ border: 'none' }}>{MODE_MAP[v]}</Tag> },
    { title: '分润比例', key: 'ratio', width: 180, render: (_, r) => renderRatio(r) },
    { title: '配置级别', dataIndex: 'level', width: 150, render: (v) => <Tag color={v === 'top' ? 'blue' : 'green'} style={{ border: 'none' }}>{LEVEL_MAP[v]}</Tag> },
    { title: '生效状态', dataIndex: 'status', width: 90, render: (v) => <Tag color={v === 'active' ? 'green' : 'default'} style={{ border: 'none' }}>{v === 'active' ? '生效中' : '已停用'}</Tag> },
    { title: '最近修改', dataIndex: 'updateTime', width: 150, render: (v) => <Text type="secondary" style={{ fontSize: 12 }}>{v}</Text> },
  ];

  return (
    <>
      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Form layout="inline">
          <Form.Item label="分润企业" style={{ marginBottom: 0 }}>
            <Input placeholder="搜索企业名称/ID" prefix={<SearchOutlined />} style={{ width: 170 }} value={filterFromEnt} onChange={(e) => setFilterFromEnt(e.target.value)} allowClear />
          </Form.Item>
          <Form.Item label="分润对象" style={{ marginBottom: 0 }}>
            <Input placeholder="搜索企业名称/ID" prefix={<SearchOutlined />} style={{ width: 170 }} value={filterToEnt} onChange={(e) => setFilterToEnt(e.target.value)} allowClear />
          </Form.Item>
          <Form.Item label="级别" style={{ marginBottom: 0 }}>
            <Select placeholder="全部" allowClear style={{ width: 140 }} value={filterLevel} onChange={setFilterLevel}>
              <Option value="top">App企业 → 设备企业</Option>
              <Option value="sub">设备企业 → 下级分销</Option>
            </Select>
          </Form.Item>
          <Form.Item label="状态" style={{ marginBottom: 0 }}>
            <Select placeholder="全部" allowClear style={{ width: 110 }} value={filterStatus} onChange={setFilterStatus}>
              <Option value="active">生效中</Option>
              <Option value="stopped">已停用</Option>
            </Select>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button icon={<ReloadOutlined />} onClick={() => { setFilterFromEnt(''); setFilterToEnt(''); setFilterLevel(undefined); setFilterStatus(undefined); }}>重置</Button>
          </Form.Item>
        </Form>
      </Card>
      <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Table columns={columns} dataSource={filtered} rowKey="key" bordered={false} scroll={{ x: 1350 }}
          locale={{ emptyText: '暂未配置分润规则' }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>
    </>
  );
};

// ══════════════════════════════════════════════
//  子组件：账单总览 Tab
// ══════════════════════════════════════════════
const BillsTab = () => {
  const [filterFromEnt, setFilterFromEnt] = useState('');
  const [filterToEnt, setFilterToEnt] = useState('');
  const [filterDate, setFilterDate] = useState([]);
  const [detailVisible, setDetailVisible] = useState(false);
  const [detailRecord, setDetailRecord] = useState(null);

  const filtered = MOCK_BILLS.filter((r) => {
    if (filterFromEnt && !(r.fromEntName + r.fromEntId).toLowerCase().includes(filterFromEnt.toLowerCase())) return false;
    if (filterToEnt && !(r.toEntName + r.toEntId).toLowerCase().includes(filterToEnt.toLowerCase())) return false;
    if (filterDate && filterDate.length === 2) {
      const bill = new Date(r.billDate).getTime();
      if (bill < filterDate[0].startOf('day').valueOf() || bill > filterDate[1].endOf('day').valueOf()) return false;
    }
    return true;
  });

  const totalCNY = filtered.filter((r) => r.currency === 'CNY').reduce((sum, r) => sum + (r.amount || 0), 0);
  const totalUSD = filtered.filter((r) => r.currency === 'USD').reduce((sum, r) => sum + (r.amount || 0), 0);

  const columns = [
    { title: '账单日期', dataIndex: 'billDate', width: 110 },
    { title: '分润企业（支出方）', dataIndex: 'fromEntName', width: 150, render: (text, r) => <div><Text strong>{text}</Text><br /><Text type="secondary" style={{ fontSize: 12 }}>{r.fromEntId}</Text></div> },
    { title: '分润对象（收入方）', dataIndex: 'toEntName', width: 150, render: (text, r) => <div><Text>{text}</Text><br /><Text type="secondary" style={{ fontSize: 12 }}>{r.toEntId}</Text></div> },
    { title: '分润 App', dataIndex: 'appName', width: 170, render: (text, r) => <div><Text>{text}</Text><br /><Text type="secondary" style={{ fontSize: 12 }}>{r.appId}</Text></div> },
    { title: '上级总收益', dataIndex: 'totalRevenue', width: 115, render: (v) => v === '—' ? <span style={{ color: '#ccc' }}>—</span> : <Text>{v}</Text> },
    { title: <Space size={4}>活跃设备数<Tooltip title="支出方活跃 / 上级总活跃"><Text type="secondary" style={{ fontSize: 12, cursor: 'help' }}>ⓘ</Text></Tooltip></Space>, key: 'active', width: 130,
      render: (_, r) => r.activeDenom > 0
        ? <Text>{r.activeNum}<Text type="secondary" style={{ fontSize: 12 }}>/{r.activeDenom}</Text></Text>
        : <span style={{ color: '#ccc' }}>-</span> },
    { title: '分润比例', key: 'ratio', width: 110,
      render: (_, r) => r.ratio != null
        ? <Space size={4}>{r.ratio}%{r.customCountryCount > 0 && <Tag color="orange" style={{ border: 'none' }}>自定义{r.customCountryCount}国</Tag>}</Space>
        : <span style={{ color: '#ccc' }}>-</span> },
    { title: '币种', dataIndex: 'currency', width: 65, render: (v) => <Tag color={v === 'CNY' ? 'green' : 'blue'} style={{ border: 'none' }}>{v}</Tag> },
    { title: '分润金额', dataIndex: 'amount', width: 125,
      render: (v, r) => <Text strong style={{ color: v < 0 ? '#ff4d4f' : '#1677ff' }}>{r.currency === 'CNY' ? '¥' : '$'}{Math.abs(v).toLocaleString()}</Text> },
    { title: '出账方式', dataIndex: 'billType', width: 105,
      render: (v, r) => v === 'adjust' && r.remark
        ? <Tooltip title={r.remark}><Tag color="orange" style={{ border: 'none', cursor: 'pointer' }}>人工冲账</Tag></Tooltip>
        : <Tag color={v === 'system' ? 'blue' : 'orange'} style={{ border: 'none' }}>{BILL_TYPE_MAP[v]}</Tag> },
    {
      title: '操作', key: 'action', width: 100, fixed: 'right',
      render: (_, r) => <Button type="link" size="small" icon={<FileTextOutlined />} onClick={() => { setDetailRecord(r); setDetailVisible(true); }}>查看明细</Button>,
    },
  ];

  return (
    <>
      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Form layout="inline">
          <Form.Item label="分润企业" style={{ marginBottom: 0 }}>
            <Input placeholder="搜索企业名称/ID" prefix={<SearchOutlined />} style={{ width: 170 }} value={filterFromEnt} onChange={(e) => setFilterFromEnt(e.target.value)} allowClear />
          </Form.Item>
          <Form.Item label="分润对象" style={{ marginBottom: 0 }}>
            <Input placeholder="搜索企业名称/ID" prefix={<SearchOutlined />} style={{ width: 170 }} value={filterToEnt} onChange={(e) => setFilterToEnt(e.target.value)} allowClear />
          </Form.Item>
          <Form.Item label="账单日期" style={{ marginBottom: 0 }}>
            <RangePicker value={filterDate} onChange={setFilterDate} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button icon={<ReloadOutlined />} onClick={() => { setFilterFromEnt(''); setFilterToEnt(''); setFilterDate([]); }}>重置</Button>
          </Form.Item>
        </Form>
      </Card>

      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
            <Statistic title="分润总额（¥）" value={totalCNY} precision={2} prefix="¥" valueStyle={{ color: '#1677ff', fontWeight: 'bold' }} />
          </Card>
        </Col>
        <Col span={12}>
          <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
            <Statistic title="分润总额（$）" value={totalUSD} precision={2} prefix="$" valueStyle={{ color: '#52c41a', fontWeight: 'bold' }} />
          </Card>
        </Col>
      </Row>

      <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Table columns={columns} dataSource={filtered} rowKey="key" bordered={false} scroll={{ x: 1400 }}
          locale={{ emptyText: '暂无分润账单' }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>

      {/* 明细抽屉（国家拆解） */}
      <Drawer title="账单明细（国家拆解）" open={detailVisible} onClose={() => setDetailVisible(false)} width={640}>
        {detailRecord && (
          <>
            <Descriptions bordered column={1} size="small" style={{ marginBottom: 24 }}>
              <Descriptions.Item label="账单日期">{detailRecord.billDate}</Descriptions.Item>
              <Descriptions.Item label="分润企业（支出方）">{detailRecord.fromEntName}（{detailRecord.fromEntId}）</Descriptions.Item>
              <Descriptions.Item label="分润对象（收入方）">{detailRecord.toEntName}（{detailRecord.toEntId}）</Descriptions.Item>
              <Descriptions.Item label="分润 App">{detailRecord.appName}（{detailRecord.appId}）</Descriptions.Item>
              <Descriptions.Item label="出账方式">
                <Tag color={detailRecord.billType === 'system' ? 'blue' : 'orange'} style={{ border: 'none' }}>{BILL_TYPE_MAP[detailRecord.billType]}</Tag>
              </Descriptions.Item>
              {detailRecord.remark && <Descriptions.Item label="备注">{detailRecord.remark}</Descriptions.Item>}
            </Descriptions>

            {detailRecord.billType === 'system' && detailRecord.countries.length > 0 ? (
              <>
                <div style={{ marginBottom: 8 }}><Text strong>国家收益明细（{detailRecord.currency}）</Text></div>
                <Table
                  size="small"
                  rowKey="country"
                  dataSource={detailRecord.countries}
                  pagination={false}
                  columns={[
                    { title: '国家', dataIndex: 'country', width: 100 },
                    { title: '活跃设备数', key: 'active', width: 140,
                      render: (_, c) => <Text>{c.activeNum}<Text type="secondary" style={{ fontSize: 12 }}>/{c.activeDenom}</Text></Text> },
                    { title: '分润比例', dataIndex: 'ratio', width: 90, render: (v) => <Text style={{ color: '#1677ff' }}>{v}%</Text> },
                    { title: '分润金额', dataIndex: 'amount', width: 130, align: 'right',
                      render: (v, c) => <Text strong>{c.currency === 'CNY' ? '¥' : '$'}{Math.abs(v).toLocaleString()}</Text> },
                  ]}
                />
                <div style={{ marginTop: 16, textAlign: 'right' }}>
                  <Text type="secondary">合计：</Text>
                  <Text strong style={{ color: '#1677ff', fontSize: 16 }}>
                    {detailRecord.currency === 'CNY' ? '¥' : '$'}{Math.abs(detailRecord.amount).toLocaleString()}
                  </Text>
                </div>
              </>
            ) : (
              <Text type="secondary">该记录为人工冲账，无国家明细。</Text>
            )}
          </>
        )}
      </Drawer>
    </>
  );
};

// ══════════════════════════════════════════════
//  主组件：分润监管
// ══════════════════════════════════════════════
const Supervise = () => (
  <div style={{ padding: 24 }}>
    <div style={{ marginBottom: 16 }}><Title level={4}>分润监管</Title></div>
    <Tabs defaultActiveKey="rules" items={[
      { key: 'rules', label: '规则总览', children: <RulesTab /> },
      { key: 'bills', label: '账单总览', children: <BillsTab /> },
    ]} />
  </div>
);

export default Supervise;
